import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "relative w-full h-full flex-grow flex overflow-x-auto scrollbar" }
const _hoisted_2 = { class: "flex flex-col w-full h-full" }
const _hoisted_3 = { class: "flex-shrink-0 flex gap-2 p-4 items-center justify-between font-light" }
const _hoisted_4 = { class: "flex items-center pr-2 gap-2" }
const _hoisted_5 = { class: "flex items-center gap-3" }
const _hoisted_6 = {
  key: 0,
  class: "text-sm flex items-center"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 1,
  class: "h-4 w-4 ml-2"
}
const _hoisted_9 = { class: "relative h-5 w-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 items-center" }, " Audit trail ", -1)
const _hoisted_11 = { class: "relative h-5 w-5" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 items-center" }, " Download PDF ", -1)
const _hoisted_13 = { class: "relative h-5 w-5" }
const _hoisted_14 = {
  key: 0,
  class: "absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center flex-col"
}
const _hoisted_15 = { class: "flex gap-3 items-center" }
const _hoisted_16 = { class: "relative h-5 w-5" }
const _hoisted_17 = {
  key: 0,
  class: "absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center flex-col"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 items-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Archive")
], -1)
const _hoisted_19 = {
  key: 0,
  class: "absolute top-0 bottom-0 h-full left-0 right-0 bg-white flex flex-col items-center z-10 gap-4 pt-10"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Loading PDF...", -1)
const _hoisted_21 = {
  key: 0,
  class: "flex items-center flex-col gap-4 justify-center text-center h-full"
}
const _hoisted_22 = { class: "text-center text-sm" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = {
  key: 0,
  class: "absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center"
}
const _hoisted_26 = ["data-js-page"]
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "w-full bg-gray-100 flex items-center justify-center h-10" }
const _hoisted_29 = {
  key: 2,
  class: "flex items-center flex-col gap-4 justify-center text-center h-full"
}
const _hoisted_30 = {
  key: 0,
  class: "w-full max-w-26rem h-full border-solid border-0 border-l outline-none details-block flex flex-col gap-4 p-4 flex-shrink-0"
}
const _hoisted_31 = { class: "flex flex-col" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Document ID ", -1)
const _hoisted_33 = { class: "flex gap-4 items-center" }
const _hoisted_34 = { class: "flex flex-col flex-grow overflow-auto scrollbar gap-4" }
const _hoisted_35 = { class: "flex flex-col" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Document details:", -1)
const _hoisted_37 = { class: "text-sm" }
const _hoisted_38 = { class: "text-sm" }
const _hoisted_39 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_40 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_41 = { class: "text-sm" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", null, " Full Document Summary ", -1)
const _hoisted_43 = { class: "pt-2 whitespace-pre-line" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = {
  key: 0,
  class: "text-sm transition-mh overflow-auto scrollbar h-sreen"
}
const _hoisted_46 = { class: "pt-2 whitespace-pre-line" }

import { ref, computed } from 'vue';
import {
	SvgIcon,
	Tooltip,
	UiCard,
	UiLoader,
	BorderedButton,
	UiFormError
} from '@/ui-kit';
import { useToggle } from '@vueuse/core';
import copy from 'copy-to-clipboard';
import { useVirtualMailbox } from '../use-virtual-mailbox';
import { useRoute, useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';
import { useCompanyProfile } from '@/account';
import VirtualMailAuditTrailDialog from '../components/VirtualMailAuditTrailDialog.vue';
import {
	httpService,
	toCurrency,
	downloadFile
} from '@/utils';
import { Mail } from '../mail';
import { AxiosError } from 'axios';
import {
	format,
	addMonths,
	differenceInDays,
	addDays
} from 'date-fns';
import {
	RoutableSyncButton,
	QuickBooksPanel,
	AppfolioButton
} from '@/interations';
import { useIntegrations } from '@/interations/use-intergations';
import DoorLoopPanel from '@/interations/components/DoorLoopPanel.vue';
import { useDoorLoop } from '@/interations/use-door-loop';
import { useBilling } from '@/billing';
import { Mailbox } from '../mailbox';


export default /*#__PURE__*/_defineComponent({
  __name: 'VirtualMailboxDetails',
  setup(__props) {

const {
	items,
	setMail,
	dispose,
	cancelDispose,
	archive,
	loadMail,
	getMailDetails,
	isMailDetailsLoaded
} = useVirtualMailbox();
const { quickbooksIntegration, loadQuickbooks } =
	useIntegrations();
const route = useRoute();
const { isBalanceBelowThreshold } = useCompanyProfile();
const { isConnected, loadDoorLoop } = useDoorLoop();
const { getProductSettings } = useBilling();

loadQuickbooks();
loadDoorLoop();
loadMail(
	Number(route.params.boxId),
	Number(route.params.id)
);

const auditTrailDialog =
	ref<InstanceType<typeof VirtualMailAuditTrailDialog>>();

const selectedMail = computed(() =>
	getMailDetails(Number(route.params.id))
);

const selectedMailbox = computed(() => {
	return items.value.find(
		(item) =>
			item.id ===
			selectedMail.value?.virtual_mailbox_id
	);
});

const [isCopied, toggleIsCopied] = useToggle();
const detailsBlock = ref<HTMLDivElement>();

function copyId(id: string) {
	toggleIsCopied(true);
	copy(id, { message: 'copied' });
	setTimeout(() => {
		toggleIsCopied(false);
	}, 1500);
}
const loaded = computed(() => {
	if (isPaidAccount.value) {
		return (
			selectedMailbox.value &&
			isMailDetailsLoaded(Number(route.params.id)) &&
			getProductSettings(
				selectedMailbox.value?.subscription_item
			)
		);
	}

	return (
		selectedMailbox.value &&
		isMailDetailsLoaded(Number(route.params.id))
	);
});

const detailsOpened = ref(false);
const pageDetailsOpened = ref(0);
const router = useRouter();

const [isPerformingAction, setIsPerformingAction] =
	useToggle();

function togglePageDetails(pageNum: number) {
	detailsOpened.value = false;
	pageDetailsOpened.value =
		pageDetailsOpened.value === pageNum ? 0 : pageNum;
}

const { success } = useToast();

async function toggleDispose() {
	setIsPerformingAction(true);
	const boxId = Number(route.params.boxId);
	const mailId = Number(route.params.id);
	if (!selectedMail.value?.mark_for_disposal) {
		await dispose(boxId, mailId);
		success(`Mail marked for disposal.`, {
			position: 'bottom-right' as any
		});
		return router.push({ name: 'VirtualMailboxInbox' });
	} else {
		await cancelDispose(boxId, mailId);
		success(`Mail restored from disposal.`, {
			position: 'bottom-right' as any
		});
	}
	setIsPerformingAction(false);
}

async function archiveMail() {
	setIsPerformingAction(true);
	const boxId = Number(route.params.boxId);
	const mailId = Number(route.params.id);
	await archive(boxId, mailId);
	success(`Mail was archived.`, {
		position: 'bottom-right' as any
	});
	setIsPerformingAction(false);
	return router.push({ name: 'VirtualMailboxInbox' });
}

const unlockPrice = computed(() => {
	const price = getProductSettings(
		selectedMailbox.value?.subscription_item
	);
	const currentUsage =
		selectedMailbox.value?.current_usage?.mail_pages ||
		0;
	const totalPages = selectedMail.value?.total_pages || 0;
	const leftPagesToUse =
		(price?.pages_included || 0) - currentUsage;
	const overagePrice = price?.overage_price || 0;

	if (leftPagesToUse <= 0) {
		return toCurrency(
			selectedMail.value!.total_pages * overagePrice
		);
	}

	if (totalPages < leftPagesToUse) {
		return 'free';
	}

	return toCurrency(
		(totalPages - leftPagesToUse) * overagePrice
	);
});

const { isPaidAccount, balanceRaw } = useCompanyProfile();

const [isUnlocking, setIsUnlocking] = useToggle();

const error = ref('');

const onError = (e: AxiosError) => {
	if (!e.response || !e.response.data) {
		return;
	}

	if (e.response.data.error || e.response.data.message) {
		error.value =
			e.response.data.error ||
			e.response.data.message;
	}

	if (e.response.data.errors) {
		error.value =
			Object.values(
				e.response.data.errors as Record<
					string,
					string[]
				>
			)[0]?.[0] || '';
	}
};

async function unlockMail() {
	if (!selectedMail.value) {
		return;
	}

	setIsUnlocking(true);
	try {
		const newMail = await httpService.post<Mail>(
			`company/virtual-mailbox/items/${selectedMail.value.virtual_mailbox_id}/mails/${selectedMail.value.id}/unlock`
		);
		setMail(newMail);
	} catch (e) {
		onError(e as AxiosError);
	} finally {
		setIsUnlocking(false);
	}
}

const shredDate = computed(() => {
	if (
		!selectedMail.value ||
		!selectedMail.value.marked_for_disposal_at
	) {
		return '';
	}

	try {
		return format(
			addDays(
				new Date(
					selectedMail.value.marked_for_disposal_at
				),
				30
			),
			'MMM d, yyyy'
		);
	} catch (e) {
		return '';
	}
});

function toDate(dateString?: string): string {
	if (!dateString) {
		return '';
	}

	try {
		return format(
			new Date(dateString + 'Z'),
			'MMM d, yyyy'
		);
	} catch (e) {
		return '';
	}
}

const backLink = history.state.back
	? history.state.back
	: { name: 'VirtualMailboxInbox' };

const expiringLabel = computed(() => {
	if (!selectedMail.value) {
		return null;
	}

	const mail = selectedMail.value.created_at;

	const diffInDays = differenceInDays(
		addDays(new Date(mail), 30),
		new Date()
	);

	if (diffInDays > 9) {
		return null;
	}

	if (diffInDays <= 0) {
		return 'Expired';
	}

	if (diffInDays === 1) {
		return `Expiring in ${diffInDays} day`;
	}

	return `Expiring in ${diffInDays} days`;
});

const isHovered = ref(false);

function isCurrentUsagePlanLimitReached(
	item?: Mailbox
): boolean {
	if (!item) {
		return false;
	}

	const currentUsage =
		item.current_usage?.mail_pages || 0;
	const productUsage =
		getProductSettings(item.subscription_item)
			?.pages_included || 0;

	return currentUsage >= productUsage;
}

function getItemUsage(item?: Mailbox): string {
	if (!item) {
		return '';
	}

	const currentUsage =
		item.current_usage?.mail_pages || 0;
	const productUsage =
		getProductSettings(item.subscription_item)
			?.pages_included || 0;

	return `<span class="${
		isCurrentUsagePlanLimitReached(item)
			? 'text-red-400'
			: ''
	} ">
		${currentUsage} </span> / ${productUsage} `;
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createVNode(_component_RouterLink, { to: _unref(backLink) }, {
          default: _withCtx(() => [
            _createVNode(_unref(BorderedButton), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(SvgIcon), {
                    name: "BackArrowIcon",
                    class: "h-3 w-3"
                  }),
                  _createTextVNode(" Back ")
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("div", _hoisted_5, [
          (_unref(isPaidAccount))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createTextVNode(" Current usage: "),
                _createElementVNode("span", {
                  innerHTML: 
								getItemUsage(
									_unref(selectedMailbox)
								)
							
                }, null, 8, _hoisted_7),
                (
								isCurrentUsagePlanLimitReached(
									_unref(selectedMailbox)
								)
							)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "group relative",
                      onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (isHovered.value = true)),
                      onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (isHovered.value = false))
                    }, [
                      _createVNode(_unref(SvgIcon), {
                        class: "h-4 w-4 ml-2",
                        name: "info"
                      }),
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (
									_ctx.$router.push({
										name: 'CurrentSubscription'
									})
								)),
                        class: _normalizeClass(["transition absolute -bottom-5 opacity-0 text-xs w-68 items-center underline cursor-pointer bg-white shadow-md py-1 px-2 -translate-x-1/2 transform group-hover:opacity-100", 
									isHovered.value
										? 'z-10'
										: '-z-1'
								])
                      }, " Save funds by purchasing bigger volume plan ", 2)
                    ], 32))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8))
              ]))
            : _createCommentVNode("", true),
          (
							_unref(selectedMail) &&
							_unref(selectedMail).total_pages
						)
            ? (_openBlock(), _createBlock(_unref(BorderedButton), {
                key: 1,
                class: "text-xs"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_unref(selectedMail).total_pages) + " pages", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (
							_unref(selectedMailbox) && _unref(selectedMail)
						)
            ? (_openBlock(), _createBlock(_unref(Tooltip), { key: 2 }, {
                popper: _withCtx(() => [
                  _hoisted_10
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(BorderedButton), {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (
								auditTrailDialog.value?.openDialog()
							))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_unref(SvgIcon), {
                          name: "info",
                          class: "h-5 w-5"
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(Tooltip), null, {
            popper: _withCtx(() => [
              _hoisted_12
            ]),
            default: _withCtx(() => [
              (
								_unref(selectedMail) &&
								_unref(selectedMail).document
							)
                ? (_openBlock(), _createBlock(_unref(BorderedButton), {
                    key: 0,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (
								_unref(downloadFile)(
									_unref(selectedMail).document
										.path
								)
							))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_unref(SvgIcon), {
                          name: "download",
                          class: "h-5 w-5"
                        })
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_unref(Tooltip), null, {
            popper: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", null, _toDisplayString(_unref(selectedMail)?.mark_for_disposal
										? 'Restore from disposal'
										: 'Mark to dispose'), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(BorderedButton), { onClick: toggleDispose }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    (
										_unref(isPerformingAction)
									)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_unref(UiLoader), { isSmall: "" })
                        ]))
                      : (_openBlock(), _createBlock(_unref(SvgIcon), {
                          key: 1,
                          name: 
										_unref(selectedMail)?.mark_for_disposal
											? 'restore'
											: 'delete'
									,
                          class: "h-5 w-5"
                        }, null, 8, ["name"]))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(Tooltip), null, {
            popper: _withCtx(() => [
              _hoisted_18
            ]),
            default: _withCtx(() => [
              (!_unref(selectedMail)?.archived)
                ? (_openBlock(), _createBlock(_unref(BorderedButton), {
                    key: 0,
                    onClick: archiveMail
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        (
										_unref(isPerformingAction)
									)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createVNode(_unref(UiLoader), { isSmall: "" })
                            ]))
                          : (_openBlock(), _createBlock(_unref(SvgIcon), {
                              key: 1,
                              name: "archive",
                              class: "h-5 w-5"
                            }))
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", {
        class: "flex-grow flex flex-col h-full relative overflow-auto scrollbar min-h-300",
        ref_key: "detailsBlock",
        ref: detailsBlock
      }, [
        (!_unref(loaded))
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_unref(UiLoader))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["transition p-4 flex flex-col gap-4", 
						_unref(loaded) ? 'opacity-100' : 'opacity-0'
					])
        }, [
          (
							_unref(selectedMail)?.is_hidden &&
							_unref(selectedMail)?.pages_generated
						)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(_unref(SvgIcon), {
                  name: "LockIcon",
                  class: "h-8 w-8"
                }),
                _createElementVNode("p", _hoisted_22, [
                  _createTextVNode(" Virtual mail is locked. "),
                  (
									_unref(isBalanceBelowThreshold)
								)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_23,
                        _createTextVNode(" Top up your balance, then click to unlock. "),
                        _hoisted_24,
                        _createVNode(_component_RouterLink, {
                          to: {
										name: 'CurrentSubscription'
									},
                          class: "underline text-sm"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Top up balance ")
                          ]),
                          _: 1
                        })
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                (!_unref(isBalanceBelowThreshold))
                  ? (_openBlock(), _createBlock(_unref(BorderedButton), {
                      key: 0,
                      disabled: _unref(isUnlocking),
                      class: "relative",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (unlockMail()))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(
									_unref(isUnlocking)
										? 'opacity-0'
										: 'opacity-100'
								)
                        }, " Unlock mail content for " + _toDisplayString(_unref(unlockPrice)), 3),
                        (_unref(isUnlocking))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createVNode(_unref(UiLoader))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                _createVNode(_unref(UiFormError), {
                  class: "mt-4",
                  errorMessage: error.value
                }, null, 8, ["errorMessage"])
              ]))
            : (
							_unref(selectedMail)?.pages_generated
						)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(selectedMail)?.pages, (page, i) => {
                  return (_openBlock(), _createBlock(_unref(UiCard), {
                    theme: "white",
                    key: i
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex flex-col page",
                        "data-js-page": page
                      }, [
                        (page.document)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: 
										page.document.path
									,
                              onLoad: _cache[6] || (_cache[6] = ($event: any) => (loaded.value = true))
                            }, null, 40, _hoisted_27))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" No document available on this page ")
                            ], 64)),
                        _createElementVNode("div", _hoisted_28, " Page " + _toDisplayString(page.page_num), 1)
                      ], 8, _hoisted_26)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              : (_openBlock(), _createElementBlock("div", _hoisted_29, " Virtual mail is processing... "))
        ], 2)
      ], 512)
    ]),
    (_unref(selectedMail) && _unref(loaded))
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createTextVNode(_toDisplayString(_unref(selectedMail)?.json_file.DCN) + " ", 1),
              _createVNode(_unref(Tooltip), {
                showTriggers: [],
                hideTriggers: [],
                placement: "bottom",
                shown: _unref(isCopied),
                delay: { show: 0, hide: 0 }
              }, {
                popper: _withCtx(() => [
                  _createTextVNode(" Copied ")
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(SvgIcon), {
                    class: "h-4 w-4 cursor-pointer select-none",
                    name: "copy",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (
								copyId(
									_unref(selectedMail)?.json_file
										.DCN
								)
							))
                  })
                ]),
                _: 1
              }, 8, ["shown"]),
              _createVNode(_unref(AppfolioButton), {
                id: _unref(selectedMail).id,
                type: "virtual-mails"
              }, null, 8, ["id"]),
              _createVNode(_unref(RoutableSyncButton), {
                id: _unref(selectedMail).id,
                pages: 
							_unref(selectedMail)?.pages?.length || 0
						,
                type: "virtual-mails"
              }, null, 8, ["id", "pages"])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_unref(UiCard), { theme: "white" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("span", _hoisted_37, "Date received: " + _toDisplayString(toDate(
									_unref(selectedMail)?.json_file
										.RECEIVED_DATE
								)), 1),
                  _createElementVNode("span", _hoisted_38, "Date scanned: " + _toDisplayString(toDate(
									_unref(selectedMail)?.json_file
										.SCAN_DATE
								)), 1),
                  (_unref(expiringLabel))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_unref(expiringLabel)), 1))
                    : _createCommentVNode("", true),
                  (_unref(shredDate))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, "Shred date: " + _toDisplayString(_unref(shredDate)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_41, "Sender: " + _toDisplayString(_unref(selectedMail)?.json_file
									.SENDER_NAME), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(UiCard), { theme: "white" }, {
              default: _withCtx(() => [
                _createElementVNode("header", {
                  class: _normalizeClass(["flex justify-between items-center transition hover:bg-gray-200 cursor-pointer px-4 -mx-4 select-none", {
							'bg-gray-200': detailsOpened.value
						}]),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => {
							detailsOpened.value = !detailsOpened.value;
							pageDetailsOpened.value = 0;
						})
                }, [
                  _hoisted_42,
                  _createVNode(_unref(SvgIcon), {
                    name: "arrow",
                    class: "h-3.5 w-3.5 transition transform rotate-90"
                  })
                ], 2),
                (detailsOpened.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["text-sm overflow-auto scrollbar h-sreen", 
							detailsOpened.value
								? 'max-h-300'
								: 'max-h-0'
						])
                    }, [
                      _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(selectedMail)?.summary ||
								'Processing...'), 1)
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedMail).pages, (page) => {
              return (_openBlock(), _createBlock(_unref(UiCard), {
                theme: "white",
                key: page.page_num
              }, {
                default: _withCtx(() => [
                  _createElementVNode("header", {
                    class: _normalizeClass(["flex justify-between items-center transition hover:bg-gray-200 cursor-pointer px-4 -mx-4 select-none", {
							'bg-gray-200':
								pageDetailsOpened.value ===
								page.page_num
						}]),
                    onClick: ($event: any) => (
							togglePageDetails(page.page_num)
						)
                  }, [
                    _createElementVNode("span", null, " Page " + _toDisplayString(page.page_num) + " summary ", 1),
                    _createVNode(_unref(SvgIcon), {
                      name: "arrow",
                      class: "h-3.5 w-3.5 transition transform rotate-90"
                    })
                  ], 10, _hoisted_44),
                  (
							pageDetailsOpened.value ===
							page.page_num
						)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, _toDisplayString(page?.summary ||
								'No summary for this page.'), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            (
						_unref(quickbooksIntegration) &&
						_unref(selectedMail)
					)
              ? (_openBlock(), _createBlock(_unref(QuickBooksPanel), {
                  key: 0,
                  id: _unref(selectedMail).id,
                  virtual_mail_pages: 
						_unref(selectedMail).total_pages
					
                }, null, 8, ["id", "virtual_mail_pages"]))
              : _createCommentVNode("", true),
            (_unref(isConnected))
              ? (_openBlock(), _createBlock(DoorLoopPanel, { key: 1 }))
              : _createCommentVNode("", true),
            (_unref(selectedMailbox) && _unref(selectedMail))
              ? (_openBlock(), _createBlock(VirtualMailAuditTrailDialog, {
                  key: 2,
                  mailbox: _unref(selectedMailbox),
                  selectedMail: _unref(selectedMail),
                  ref_key: "auditTrailDialog",
                  ref: auditTrailDialog
                }, null, 8, ["mailbox", "selectedMail"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})